import { Box, Button, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { Modal } from '../../../modals/Modal';
import type { ActionConfirmationModalProps } from './types';

export function ActionConfirmationModal({
  isOpen,
  severity,
  content,
  isLoading = false,
  onClose,
  onConfirm,
}: ActionConfirmationModalProps) {
  return (
    <Modal
      open={isOpen}
      onClose={isLoading ? () => {} : onClose}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 2,
        '& > .MuiBox-root': {
          width: '100%',
          maxWidth: 420,
          borderRadius: '16px',
          overflow: 'hidden',
        },
      }}
    >
      <Modal.Header>
        <Box sx={{ pt: 1, pb: 1, bgcolor: 'primary.main' }}>
          <Typography
            component="h2"
            sx={{
              px: 2.5,
              fontWeight: 700,
              fontSize: { xs: '16px', sm: '18px' },
              color: '#ffffff',
              textAlign: 'center',
            }}
          >
            {content.title}
          </Typography>
        </Box>
      </Modal.Header>

      <Modal.Body>
        <Box sx={{ px: 2, pt: 2, bgcolor: '#fff' }}>
          <Typography sx={{ fontSize: '14px', lineHeight: 1.65, color: '#1A1A1A', textAlign: 'left' }}>
            {content.message}
          </Typography>
        </Box>

        <Box
          sx={{
            bgcolor: '#F9FAFB',
            px: 2,
            py: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 1.25,
          }}
        >
          <LoadingButton
            fullWidth
            variant="contained"
            color={severity}
            loading={isLoading}
            onClick={onConfirm}
            sx={{
              borderRadius: '8px',
              py: 1.1,
              fontSize: '14px',
              fontWeight: 600,
              textTransform: 'none',
              boxShadow: 'none',
              '&:hover': {
                boxShadow: 'none',
              },
            }}
          >
            {content.confirmLabel}
          </LoadingButton>

          <Button
            fullWidth
            variant="outlined"
            disabled={isLoading}
            onClick={onClose}
            sx={{
              borderRadius: '8px',
              py: 1.1,
              fontSize: '14px',
              fontWeight: 500,
              textTransform: 'none',
              color: '#1A1A1A',
              borderColor: '#D1D5DB',
              bgcolor: '#fff',
              '&:hover': {
                bgcolor: '#fff',
                borderColor: '#9CA3AF',
              },
            }}
          >
            Cancel
          </Button>
        </Box>
      </Modal.Body>
    </Modal>
  );
}

export default ActionConfirmationModal;
